/**                                                                       @about
@file: plugin.sort-table.ts
@desc: Logic for table/sort, built/compiled to ./www
***                                                                           */
import {
  naturalSort,
} from './sort-natural'
import {
  triggerSortEvent,
  SORT_EVENT_MAP,
} from './plugin.common'
import type {
   TriggerSortKeys,
} from './plugin.common'

// @NOTE -> options set in html via globalThis.keyboard_navigation
type GTheadSotrOpts = {
  restore_sort: boolean;
}
const gTheadSotrOpts = Object.assign({
  restore_sort: true,
}, globalThis._plugin_thead_sorter ?? {}) as GTheadSotrOpts;

/**
 * Our table snatcher, the unsung hero
 * @return {HTMLTableElement | null}
 */
const tableSnatcher = () => document.getElementById('table') as HTMLTableElement | null;


/**
 * Gets the value of a cell in a table row.
 * @param  {HTMLTableRowElement} row - table row element
 * @param  {number} colIndex - index of the cell
 * @return {string | number}
 */
const getCellValue = (row: HTMLTableRowElement, colIndex: number): string | number => {
  const cell: HTMLTableCellElement = row.children[colIndex] as HTMLTableCellElement;
  const dataSortValue = cell.getAttribute('data-sort');
  return (dataSortValue !== null
    ? dataSortValue : cell.innerText || cell.textContent || '').trim();
};

/**
 * Creates a comparison function for sorting table rows
 * @param  {number} colIndex - index of column
 * @param  {boolean} asc - if asc sort
 * @param  {boolean} isRevert = false - if sort is to be reverted
 * @return {(a: HTMLTableRowElement, b: HTMLTableRowElement) => number}
 */
const compareRowsFnFactory = (colIndex: number, asc: boolean, isRevert = false): (a: HTMLTableRowElement, b: HTMLTableRowElement) => number => {
  return isRevert
    ? (a, b) => Number(a.getAttribute('data-idx')) - Number(b.getAttribute('data-idx'))
    : (a, b): number => {
    const cellValue1: string | number = getCellValue(a, colIndex);
    const cellValue2: string | number = getCellValue(b, colIndex);
    return asc ? naturalSort(cellValue1, cellValue2) : naturalSort(cellValue2, cellValue1);
  };
};

let hackyDscOverride = false;
/**
 * OnClick/sort logic
 * @param  {MouseEvent} event
 * @return {void}
 */
const onDatClickEvent = (event: MouseEvent, tablePerf = false) => {
  const start = !tablePerf ? 0 : performance.now();
  const table = tableSnatcher()
  if (!table) { return; }
  const cell = event.currentTarget as HTMLTableCellElement;
  const tbody = table.querySelector('tbody');
  const parent = (tbody != null) ? tbody : table;
  const rows: NodeListOf<HTMLTableRowElement> = parent.querySelectorAll('tr:nth-child(n+2)');
  const cid =  cell.getAttribute('data-id');
  // hackySortOverride
  // figure out next state
  const isAsc = hackyDscOverride ? false : !cell.classList.contains('sort-dsc');
  hackyDscOverride = false;
  // only filename "unset" sort
  const isRevert = !!cell.classList.length && isAsc && cid === 'filename';
  const isDsc = !isRevert && !isAsc;
  // remove/add class
  Array.from(table.rows[0].cells).forEach(val => {
    val.classList.remove('sort-asc', 'sort-dsc')
  });
  !isRevert && cell.classList.add(!isDsc ? 'sort-dsc' : 'sort-asc');
  // sort and build
  const rowsArray = Array.from(rows);
  rowsArray.sort(compareRowsFnFactory(cell.cellIndex, isDsc, isRevert));

  // similar perf profile compared to createDocumentFragment, maybs a touch slower
  for (let i = 0; i < rowsArray.length; i++) {
    parent.appendChild(rowsArray[i]);
  }

  // (rough test of 30000 elms -> 1700ms compared to 1850ms)
  // const fragment = document.createDocumentFragment();
  // for (let i = 0; i < rowsArray.length; i++) {
  //   fragment.appendChild(rowsArray[i]);
  // }
  // parent.replaceChildren(fragment);
  start && requestAnimationFrame(() => { console.log('perf: %d', performance.now() - start ); })

  // skip if not set
  if (!gTheadSotrOpts.restore_sort) { return null; }
  // if revert we remove
  console.log('isRevert ', localStorage.getItem(`quaint.${location.href}`))
  if (isRevert) {
    localStorage.removeItem(`quaint.${location.href}`)
    return null;
  }
  const skey = SORT_EVENT_MAP[(cid ?? '') as TriggerSortKeys]
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (skey) {
    console.log(`quaint.${location.href}`, `${skey}.${isDsc ? '1' : '0'}`)
    // console.log('set  ', `quaint.${location.href} `, skey);
    localStorage.setItem(`quaint.${location.href}`, `${skey}.${isDsc ? '1' : '0'}`)
  }
};



/**
 * @INIT -> Wait a sec, so we ain't hot to trot, if surfin' the history
 */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

const prvSort = gTheadSotrOpts.restore_sort
  ? localStorage.getItem(`quaint.${location.href}`)
  : null;
const initWrap = () => {
  const table = tableSnatcher()
  if (!table || !table.rows.length) { return null; }
  const cells: HTMLCollectionOf<HTMLTableCellElement> = table.rows[0].cells;
  for (let c = 0; c < cells.length; c++) {
    cells[c].addEventListener('click', onDatClickEvent)
  }
  const [prvKey, prvAsc] = prvSort ? prvSort.split('.') : [];
  if (prvAsc === '1') {
    console.log('hackyDscOverride')
    hackyDscOverride = true;
  }
  const skey = SORT_EVENT_MAP[prvKey as TriggerSortKeys]
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  skey && triggerSortEvent(skey)
};


// Called when the page loads
prvSort &&
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initWrap)
    : initWrap()


!prvSort && setTimeout(initWrap, 500)

